import React, { useState } from 'react';
import { InputAdornment } from '@material-ui/core';

import { QRReader } from 'ui';
import { QrIcon } from '../../../ui/icons';

import { ScanFieldProps } from './ScanField.types';
import { useStyles } from './ScanField.styles';

import { GenericField } from '..';

export const ScanField = ({ onScan, ...props }: ScanFieldProps) => {
  const classes = useStyles();
  const [isScannerVisible, setScannerVisible] = useState(false);

  const handleScan = (value: string) => {
    onScan(value);
    setScannerVisible(false);
  };

  return (
    <>
      {isScannerVisible && (
        <div className={classes.qrContainer}>
          <QRReader handleError={() => null} handleRead={handleScan} />
        </div>
      )}
      <GenericField
        {...props}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" onClick={() => setScannerVisible(true)}>
              <QrIcon color="inherit" className={classes.qrIcon} />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};
